import React from 'react';
import { INPUT } from './styles';
import useDebouncedCommit from './useDebouncedCommit';

/** Free-text "contains" filter; commits after a pause or on Enter. */
const TextRenderer = ({ field, value, onChange }) => {
    const [draft, change, flush] = useDebouncedCommit(value || '', (v) => onChange(v.trim()));
    return (
        <input
            type="text"
            value={draft}
            onChange={(e) => change(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    flush();
                }
            }}
            placeholder={field.placeholder || 'Contains…'}
            aria-label={field.label}
            className={INPUT}
        />
    );
};

export default TextRenderer;
